export const statusVariants = {
    odoo_purchase_order: {
        status: {
            draft: {
                class: 'bg-light',
                label_key: 'purchase_orders.odoo_purchase_orders.states.draft',
            },
            'to approve': {
                class: 'bg-warning',
                label_key: 'purchase_orders.odoo_purchase_orders.states.to_approve',
            },
            purchase: {
                class: 'bg-success',
                label_key: 'purchase_orders.odoo_purchase_orders.states.purchase',
            },
            done: {
                class: 'bg-success-custom',
                label_key: 'purchase_orders.odoo_purchase_orders.states.done',
            },
            cancel: {
                class: 'bg-danger',
                label_key: 'purchase_orders.odoo_purchase_orders.states.cancel',
            }
        },
        invoice_status: {
            no: {
                class: 'bg-light',
                label_key: 'purchase_orders.odoo_purchase_orders.invoice_statuses.no',
            },
            'to invoice': {
                class: 'bg-warning',
                label_key: 'purchase_orders.odoo_purchase_orders.invoice_statuses.to_invoice',
            },
            invoiced: {
                class: 'bg-success',
                label_key: 'purchase_orders.odoo_purchase_orders.invoice_statuses.invoiced',
            }
        },
    },
    odoo_sale_order: {
        status: {
            draft: {
                class: 'bg-light',
                label_key: 'sale_notes.odoo_sale_orders.states.draft',
            },
            'sent': {
                class: 'bg-warning',
                label_key: 'sale_notes.odoo_sale_orders.states.to_approve',
            },
            sale: {
                class: 'bg-success',
                label_key: 'sale_notes.odoo_sale_orders.states.sale',
            },
            done: {
                class: 'bg-success-custom',
                label_key: 'sale_notes.odoo_sale_orders.states.done',
            },
            cancel: {
                class: 'bg-danger',
                label_key: 'sale_notes.odoo_sale_orders.states.cancel',
            }
        },
        invoice_status: {
            no: {
                class: 'bg-light',
                label_key: 'sale_notes.odoo_sale_orders.invoice_statuses.no',
            },
            'to invoice': {
                class: 'bg-warning',
                label_key: 'sale_notes.odoo_sale_orders.invoice_statuses.to_invoice',
            },
            invoiced: {
                class: 'bg-success',
                label_key: 'sale_notes.odoo_sale_orders.invoice_statuses.invoiced',
            }
        },
    },
    odoo_account_move: {
        status: {
            draft: {
                class: 'bg-light',
                label_key: 'odoo_account_payments.states.draft',
            },
            posted: {
                class: 'bg-primary',
                label_key: 'odoo_account_payments.states.posted',
            },
            cancel: {
                class: 'bg-danger',
                label_key: 'odoo_account_payments.states.cancel',
            }
        },
        payment_status: {
            not_paid: {
                class: 'bg-danger',
                label_key: 'odoo_account_payments.payment_states.no',
            },
            in_payment: {
                class: 'bg-warning',
                label_key: 'odoo_account_payments.payment_states.in_payment',
            },
            partial: {
                class: 'bg-primary',
                label_key: 'odoo_account_payments.payment_states.partial',
            },
            paid: {
                class: 'bg-success',
                label_key: 'odoo_account_payments.payment_states.paid',
            },
        },
    },
    user: {
        status: {
            active: {
                class: 'bg-success',
                label_key: 'active',
            },
            inactive: {
                class: 'bg-danger',
                label_key: 'inactive',
            }
        }
    },
    approval_template: {
        status: {
            active: {
                class: 'bg-success',
                label_key: 'active',
            },
            inactive: {
                class: 'bg-danger',
                label_key: 'inactive',
            }
        }
    }
}

export const getStatusVariants = (entity, type, value) => statusVariants[entity]?.[type]?.[value] || {
    class: 'bg-light',
    label_key: value,
}